// Shared video lightbox for story circles / video review cards.
// Any element with [data-j-video] opens the single <dialog id="JVideoModal">.
// data-j-mp4 = Shopify-hosted video file (preferred), data-j-video = YouTube/Vimeo URL (may be empty),
// data-j-title, data-j-quote, data-j-poster.
(() => {
  if (window.jVideoModal) return;
  window.jVideoModal = true;

  const embedUrl = (url) => {
    if (!url) return null;
    const yt = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
    if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}?autoplay=1&rel=0`;
    const vimeo = url.match(/vimeo\.com\/(\d+)/);
    if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`;
    return null;
  };

  const getModal = () => {
    let modal = document.getElementById('JVideoModal');
    if (modal) return modal;
    modal = document.createElement('dialog');
    modal.id = 'JVideoModal';
    modal.className = 'j-vmodal';
    modal.innerHTML =
      '<button type="button" class="j-vmodal__close" aria-label="Close">&times;</button>' +
      '<div class="j-vmodal__frame"></div><div class="j-vmodal__caption"></div>';
    document.body.appendChild(modal);
    const close = () => modal.close();
    modal.querySelector('.j-vmodal__close').addEventListener('click', close);
    modal.addEventListener('click', (e) => e.target === modal && close());
    modal.addEventListener('close', () => (modal.querySelector('.j-vmodal__frame').innerHTML = ''));
    return modal;
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-j-video]');
    if (!trigger) return;
    e.preventDefault();
    const modal = getModal();
    const frame = modal.querySelector('.j-vmodal__frame');
    const src = embedUrl(trigger.dataset.jVideo);
    frame.textContent = '';
    if (trigger.dataset.jMp4) {
      const video = document.createElement('video');
      video.src = trigger.dataset.jMp4;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      if (trigger.dataset.jPoster) video.poster = trigger.dataset.jPoster;
      frame.appendChild(video);
    } else if (src) {
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = trigger.dataset.jTitle || 'Customer video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      frame.appendChild(iframe);
    } else if (trigger.dataset.jPoster) {
      const img = document.createElement('img');
      img.src = trigger.dataset.jPoster;
      img.alt = trigger.dataset.jTitle || '';
      frame.appendChild(img);
    }
    const caption = modal.querySelector('.j-vmodal__caption');
    caption.textContent = '';
    if (trigger.dataset.jQuote) {
      const q = document.createElement('p');
      q.textContent = `“${trigger.dataset.jQuote}”`;
      caption.appendChild(q);
    }
    if (trigger.dataset.jTitle) {
      const n = document.createElement('strong');
      n.textContent = trigger.dataset.jTitle;
      caption.appendChild(n);
    }
    modal.showModal();
  });
})();
